export enum SourcingFulfillmentStatus {
	PENDING = 'pending',
	PO_PLACED = 'po_placed',
	RECEIVED = 'received',
	FULFILLED = 'fulfilled',
}

export type SourcingFulfillmentStatusKey =
	keyof typeof SourcingFulfillmentStatus;
export type SourcingFulfillmentStatusValue =
	(typeof SourcingFulfillmentStatus)[SourcingFulfillmentStatusKey];

export const SourcingFulfillmentStatusLabels: Record<
	SourcingFulfillmentStatusValue,
	string
> = {
	[SourcingFulfillmentStatus.PENDING]: 'Pending',
	[SourcingFulfillmentStatus.PO_PLACED]: 'PO Placed',
	[SourcingFulfillmentStatus.RECEIVED]: 'Received',
	[SourcingFulfillmentStatus.FULFILLED]: 'Fulfilled',
};

export function getSourcingFulfillmentStatusLabel(
	status: string | null | undefined,
): string {
	if (status == null) {
		return '-';
	}

	return (
		SourcingFulfillmentStatusLabels[status as SourcingFulfillmentStatusValue] ??
		'Unknown'
	);
}

export function getSourcingFulfillmentStatusColor(
	status: string | null | undefined,
): string {
	if (status == null) {
		return 'default';
	}

	switch (status) {
		case SourcingFulfillmentStatus.PENDING:
			return 'secondary';
		case SourcingFulfillmentStatus.PO_PLACED:
			return 'primary';
		case SourcingFulfillmentStatus.RECEIVED:
			return 'info';
		case SourcingFulfillmentStatus.FULFILLED:
			return 'success';
		default:
			return 'default';
	}
}
